import React from "react";
import { Box, Alert, Typography } from "@mui/material";
import AttendanceList from "../../components/features/attendance/AttendanceList";

/**
 * Attendance page: view-only. Clock-in and clock-out are recorded via the ZKTeco device (or bridge).
 */
const AttendancePage = ({ viewMode = "personal" }) => {
  return (
    <Box>
      <Alert severity="info" sx={{ mb: 2 }}>
        <Typography variant="body2">
          Clock-in and clock-out are recorded at the attendance device. Use this page to <strong>view</strong> your attendance records.
        </Typography>
      </Alert>
      <AttendanceList viewMode={viewMode === "employee" ? "employee" : "personal"} />
    </Box>
  );
};

export default AttendancePage;
